// extracted by mini-css-extract-plugin
export default {"countrySelect":"Citizenship_countrySelect__V6wN2"};